document.addEventListener('DOMContentLoaded', () => {
    const iconBlocks = document.querySelectorAll('.text-icon-block');
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
        iconBlocks.forEach((block) => {
            block.addEventListener('click', (e) => {
                e.stopPropagation();
                
                iconBlocks.forEach((otherBlock) => {
                    if (otherBlock !== block) {
                        otherBlock.classList.remove('active');
                    }
                });
                block.classList.toggle('active');
            });
        });

        document.addEventListener('click', () => {
            iconBlocks.forEach((block) => {
                block.classList.remove('active');
            });
        });
    }
});